<template>
    <div class="page">
        <div class="row reports report-monthly">
            <h2>{{reportTitle}}</h2>
            <div class="table-responsive">
                <table class="maintable reports">
                    <thead>
                        <tr v-if="report.root[0]">
                            <td>{{$t('CLIENT')}}</td>
                            <td v-for="(num, date) in report.root[0].quantityPerDate">{{date}}</td>
                            <td>{{$t('TOTAL')}}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, i) in report.root" :key="i">
                            <td>{{row.companyName}}</td>
                            <td v-for="(num, date) in row.quantityPerDate">
                                <div class="date" :class="{'empty': (num == 0)}">{{(num == 0) ? '' : num}}<!-- div class="weekend"></div --></div>
                            </td>
                            <td>{{row.num}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>{{ $t('TOTAL')+':' }}</td>
                            <td>{{report.total}}</td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

import
{
    mapActions,
    mapGetters
}
from 'vuex'
import dentalsolutiontypesApi from '@/api/dentalsolutiontypes'
import dentalsolutionsApi from '@/api/dentalsolutions'
import moment from 'moment';

export default
{
    name: 'ReportsDs',
    data: function()
    {
        return {
            dentalsolutiontypes: {
                root: [],
                totalCount: 0
            },
            companies: {
                root: [],
                totalCount: 0
            },
            report: {
                root: [],
                totalCount: 0,
                total: 0
            },
            params:
            {
                month: moment().format('M'),
                year: moment().format('YYYY'),
                ordererCompanyId: '',
                dentalSolutionTypeId: null,
            }
        };
    },
    created: function()
    {
        var me = this;

        me.params = me.$route.query;

        me.getMonthlyReport();
    },
    methods:
    {
        getMonthlyReport()
        {
            var me = this;
            const params = { ...me.params };

            params.date = moment(params.date).format('YYYY-MM-DD');

            dentalsolutionsApi.getMonthlyReport(params, function(data)
            {
                if (data.error)
                {
                    me.$notify.error(data.notice);
                }
                else
                {
                    me.report = data;
                }
            });
        }
    },
    computed: {
        ...mapGetters([
            'globals'
        ]),
        years()
        {
            const data = [];

            for(let i=2020;i<2040;i++)
            {
                data.push(i);
            }

            return data;
        },
        months()
        {
            const data = [];

            for(let i=1;i<=12;i++)
            {
                if(String(i).length == 1)
                {
                    data.push('0'+String(i));
                }
                else
                {
                    data.push(String(i));
                }
            }

            return data;
        },
        getQueryParams()
        {
            const me = this;

            return {
                ...me.params,
                date: moment(me.params.date).format('YYYY-MM-DD')            
            }
        },
        reportTitle()
        {
            const me = this;

            if(me.report.reportHeader !== undefined)
            {
                return me.report.reportHeader.date+' '+me.report.reportHeader.name;   
            }

            return '';
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/PrintDsMonthly.vue